



























































import Vue from 'vue';
import { MeterMapping } from './MeterMapping';
import DefaultLocationProp from '@/Shared/DefaultLocationProp';
import VatsAPI from '@/Shared/VatsAPI';
import { getValidationErrors } from '@/Shared/ValidationErrorDirective';

export default Vue.extend({
    props: {
        mapping: {
            type: Object as () => MeterMapping,
            validator: (): boolean => true,
            required: true
        },
        location: DefaultLocationProp,
    },
    data() {
        return {
            isLoading: false,
            isEditing: false,
            workingCopy: Object.assign({}, this.mapping) as MeterMapping,
            validationErrors: {} as { [propName: string]: string[] }
        };
    },
    beforeMount() {
        if (!this.mapping.recID) {
            this.isEditing = true;
        }
    },
    methods: {
        async deleteMapping() {
            if (!this.workingCopy.recID) {
                this.$emit('deleted', this.workingCopy);
            }

            this.isLoading = true;
            try {
                await VatsAPI.delete<MeterMapping>(`${this.location}/Meters/Mappings`, {
                    data: this.workingCopy.recID,
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });
                this.validationErrors = {};
                this.$emit('deleted', this.mapping);
            }
            catch (e) {
                this.validationErrors = getValidationErrors(e.response);
                throw e;
            }
            finally {
                this.isLoading = false;
            }
        },
        edit() {
            this.isEditing = true;
        },
        cancel() {
            this.isEditing = false;
            this.$emit('cancelled', this.mapping);
        },
        async save() {
            const method = this.workingCopy.recID ? VatsAPI.put : VatsAPI.post;

            this.isLoading = true;
            try {
                const result = await method<MeterMapping>(`${this.location}/Meters/Mappings`, this.workingCopy);
                this.isEditing = false;
                this.$emit('saved', result.data || this.workingCopy);
                this.validationErrors = {};
            }
            catch (e) {
                this.validationErrors = getValidationErrors(e.response);
                throw e;
            }
            finally {
                this.isLoading = false;
            }
        },
    },
    watch: {
        location(): void {
            this.isEditing = false;
            this.isLoading = false;
        },
        mapping(): void {
            this.workingCopy = Object.assign({}, this.mapping) as MeterMapping;
        },
    },
});
